import {
	cssConfig
} from './css'

const isDev = 0
const host = isDev ? 'lxtx.com' : 'xm.jiaolun.top'
const domain = `http${(isDev ? '' : 's')}://${host}`

const config = {
	host,
	domain,
	api_base_url: `${domain}/assemble/api/v1`,
	cache: 1,
	cache_prefix: 'fet_shop_',
	order_btns: {
		'pay_btn': '支付',
		'cancel_btn': '取消',
		'receive_btn': '确认收货',
		'comment_btn': '评价',
		// 'shipping_btn' :'查看物流',
		'return_btn': '联系客服'
	},
	order_taps: {
		'pay_btn': 'payOrderTap',
		'cancel_btn': 'cancelOrderTap',
		'receive_btn': 'receiveOrderTap',
		'comment_btn': 'commentOrderTap',
		// 'shipping_btn' :'查看物流',
		'return_btn': 'returnOrderTap'
	},
	contactTel: '4008828351',
	defaultAgencyId: 0,
	...cssConfig,
	login_domain: `http${(isDev ? '' : 's')}://mendian.jiaolun.top`
}

export {
	config
}
